__turbopack_context__.v({
  "className": "jetbrains_mono_1d7a0734-module__LEDdyW__className",
  "variable": "jetbrains_mono_1d7a0734-module__LEDdyW__variable",
});
